var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('outcomes-research-wrapper',{attrs:{"_title":"Oto Graduates Map"}},[_c('outcomes-navbar'),_c('div',{attrs:{"id":"map"}}),_c('outcomes-footer',{attrs:{"copyright":_vm.copyright}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }